<template>
  <section id="one">
    <header class="major">
      <h1>{{headline}}</h1>
    </header>
    <p>{{message}}</p>
  </section>
</template>

<script>
export default {
  data: function() {
    return {
      headline: "hi folks,",
      message:
        "this is my personal website primarily presenting my collection of blogs used when traveling around the world. Additionally, i would like to present my (so far) few but growing work and research experience for those interested in. For further information or if you have any questions please do not hesitate to contact me :)"
    };
  }
};
</script>